/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('HRControllers', ['ngAnimate',
                                 'ui.bootstrap',
                                 'mgcrea.ngStrap',
                                 'angularMoment',
                                 'directives.IAMContact'
                                 ]);